import React,{ useState, useRef } from 'react';
import './styles.css';
import { useSpring, animated } from 'react-spring';
import 'bootstrap/dist/css/bootstrap.min.css';
import Arrow from '../../images/arrow.svg';
import plus from '../../images/plus.svg';
import minus from '../../images/minus.svg';
import RightLazyShow from '../rightLazyShow';

const YourRewards = () =>{
  const [showAnswer, setshowAnswer] = useState([false,false,false, false, false]);
  function hideAnswer (num) {
    const newItems = [...showAnswer];
    newItems[num] = !newItems[num];
    setshowAnswer(newItems);
  }

    return(
      <>
        <div className="yourRewardsDiv" id="rewards">
          <text className="yourRewardsHeader">YOUR REWARDS</text>
          <div className="row">
            <div className="col-lg-7 yourRewardsCol1">
            <RightLazyShow>
              <div className="ORABlueSubHeaderDiv handyRewardsDiv">
                <text className="ORABlueHeader handyRewards" onClick={()=> window.open('https://hi.switchy.io/ADAantsStakingTool','_blank')}>TRY THIS HANDY REWARDS CALCULATOR</text>
                <a href="https://hi.switchy.io/ADAantsStakingTool" target="_blank" rel="noreferrer">
                  <img src={Arrow} alt="location" className="arrowImg"/></a>
                </div>
              </RightLazyShow>
              <div className="cardBg cardBgPadding" onClick={() => hideAnswer(0)}>
              <RightLazyShow>
                <div className="question">
                  <div>
                    <text className="cardHeaderText">WHEN DO I GET MY REWARDS?</text>
                  </div>
                  <div className="plusIconsDiv">
                  {
                    showAnswer[0] == false ?
                    <img src={plus} alt="location" className="plusImg"/>
                    :
                    <img src={minus} alt="location" className="minusImg"/>
                  }
                  </div>
                </div>
                </RightLazyShow>
                {
                  showAnswer[0] == true ? 
                  <text className="carddescription"><p>Rewards will be paid out two Epochs (10 days) after you've earned them. Your first rewards are paid with a 25-day delay. You will earn rewards every 5 days (1 Epoch) from that point. For example:</p> <p>Epoch 1: Ada Staked</p><p>Epoch 2: Epoch Snapshot</p><p>Epoch 3: Block Production</p><p>Epoch 4: Rewards Calculated</p>Epoch 5: Rewards Paid</text>
                  :
                  null
                }
              </div>
              <div className="cardBg cardBgPadding" onClick={() => hideAnswer(1)}>
              <RightLazyShow>
                <div className="question">
                  <text className="cardHeaderText">WHAT IS SATURATION?</text>
                  <div className="plusIconsDiv">
                  {
                    showAnswer[1] == false ?
                    <img src={plus} alt="location" className="plusImg"/>
                    :
                    <img src={minus} alt="location" className="minusImg"/>
                  }
                  </div>
                </div>
                </RightLazyShow>
                {
                  showAnswer[1] == true ? 
                  <text className="carddescription"><p>Pool saturation is the maximum amount of stake which a pool can have after which the pool will receive diminished rewards. Pool saturation is a mechanism which prevents pool from becoming too big and also users to re-stake their ADA to new Stake pools. This overall results in decentralization.</p> <p>Pool saturation is determined by K parameter which is currently 500. And saturation point is calculated by total staked ADA divided by k. Currently this amount stand at 64 million ADA (approx.). Any pool having stake more than that will receive reduced rewards.</p>It would be a good decision to join our pool as it has less saturation</text>
                  :
                  null
                }
              </div>
            </div>
            <div className="col-lg-5 yourRewardsCol2">
              <div className="cardBg cardBgPadding" onClick={() => hideAnswer(2)}>
              <RightLazyShow>
                <div className="question">
                  <text className="cardHeaderText">HOW DO I GET MY REWARDS?</text>
                  <div className="plusIconsDiv">
                  {
                    showAnswer[2] == false ?
                    <img src={plus} alt="location" className="plusImg"/>
                    :
                    <img src={minus} alt="location" className="minusImg"/>
                  }
                  </div>
                </div>
                </RightLazyShow>
                {
                  showAnswer[2] == true ? 
                  <text className="carddescription"><RightLazyShow>During each epoch, rewards are distributed amongst all stakeholders who have delegated to a stake pool, either to their own stake pool, or another pool. These rewards are auto-generated by the protocol itself, and are not managed by the stake pool operators. The entire process is automated.</RightLazyShow></text>
                  :
                  null
                }
              </div>
              <div className="cardBg cardBgPadding" onClick={() => hideAnswer(3)}>
              <RightLazyShow>
                <div className="question">
                  <text className="cardHeaderText">WILL I LOSE REWARDS IF I SWITCH POOLS?</text>
                  <div className="plusIconsDiv">
                  {
                    showAnswer[3] == false ?
                    <img src={plus} alt="location" className="plusImg"/>
                    :
                    <img src={minus} alt="location" className="minusImg"/>
                  }
                  </div>
                </div>
                </RightLazyShow>
                {
                  showAnswer[3] == true ? 
                  <text className="carddescription"><RightLazyShow>No. You will not lose anything. It take two epochs until your stake counts for new pools. Until then you will be receiving rewards from previous pool.</RightLazyShow></text>
                  :
                  null
                }
              </div>
              <div className="cardBg cardBgPadding" onClick={() => hideAnswer(4)}>
              <RightLazyShow>
                <div className="question">
                  <text className="cardHeaderText">MY EXISTING POOL IS SATURED. WHAT SHALL I DO?</text>
                  <div className="plusIconsDiv">
                  {
                    showAnswer[4] == false ?
                    <img src={plus} alt="location" className="plusImg"/>
                    :
                    <img src={minus} alt="location" className="minusImg"/>
                  }
                  </div>
                </div>
                </RightLazyShow>
                {
                  showAnswer[4] == true ? 
                  <text className="carddescription"><RightLazyShow>If your pool is saturated, you will be receiving diminished rewards for the ADA you have staked. So you should move your ADA to pools such as MAX1 that have low saturation.</RightLazyShow></text>
                  :
                  null
                }
              </div>
            </div>
          </div>
        </div>
        <div className="separatingLine"></div>
      </>
    )
}

export default YourRewards;